import React, {Fragment, useEffect, useState} from 'react';
import {getQrtList, getQstList, getTirList, postQrt} from '../resources/services/frontController'
import {deleteQrt} from '../resources/services/frontController'
import Box from "@material-ui/core/Box";
import CreateQuestionnaire from "./CreateComponents/CreateQuestionnaire";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import Fab from "@material-ui/core/Fab";
import {Backspace, Delete, Edit} from "@material-ui/icons";
import AddIcon from '@material-ui/icons/Add';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import SpinnerHexagone from '../components/SpinnerHexagone';


const useStyles = makeStyles(theme => ({
    form: {
        width: '100%',
    },

}));


export default function Questionnaires(props) {

    const classes = useStyles();
    const [listeQrt, setListeQrt] = useState([]);
    const [listTir, setListeTir] = useState([]);
    const [libelleQrt, setLibelleQrt] = useState('');
    const [tirIdQrt, setTirIdQrt] = useState('');
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        Promise.all([
            getQrtList(), getTirList()
        ]).then(responses => {
            setListeQrt(responses[0].data);
            setListeTir(responses[1].data);
            setIsLoading(false);
        })
    }, []);

    function deleteQrtbyId(id) {
        deleteQrt(id)
            .then(response => {
                getQrtList().then(response => {
                    const data = response.data;
                    setListeQrt(data);
                });
            });
    }

    function postQrtbyId() {
        if((libelleQrt!='') && (tirIdQrt!='')) {
            postQrt([libelleQrt, tirIdQrt])
                .then(response => {
                    getQrtList().then(response => {
                        const data = response.data;
                        setListeQrt(data);
                    });
                });
        }
    }

    function addLibelle(event) {
        setLibelleQrt(event.target.value);
    }

    function addTirId(event) {
        setTirIdQrt(event.target.value);
    }

        return (
            <SpinnerHexagone isLoading={isLoading}>
                <FormControl id="myform" className={classes.form}>
                    <Grid justify='center' container spacing={2}>
                        <Grid item xs={5}>
                            <TextField
                                id="libelle_qrt"
                                label="Libelle du questionnaire"
                                name='libelle_qrt'
                                onChange={(e) => addLibelle(e)}
                                value={libelleQrt}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <TextField
                                select
                                id="tir_qrt"
                                label="Type d'intervention"
                                name="tir_qrt"
                                onChange={(e) => addTirId(e)}
                                value={tirIdQrt}
                                fullWidth
                            >
                                {listTir.map(tirRow => <MenuItem value={tirRow.tirId}>{tirRow.tirLibelle}</MenuItem>)}
                            </TextField>
                        </Grid>
                        <Grid item xs={2}>
                            <Fab type="submit" size="small" color="primary" aria-label="Add"
                                 onClick={() => postQrtbyId()}> <AddIcon/> </Fab>
                        </Grid>
                    </Grid>
                </FormControl>
                <Paper style={{marginTop: '15px', minHeight: '150px'}}>
                    <Table size="small">
                        <TableHead>
                            <TableRow className="text-center">
                                <TableCell component="td" scope="row">Libelle Questionnaire</TableCell>
                                <TableCell component="td" scope="row">Type intervention</TableCell>
                                <TableCell component="td" scope="row">Supprimer</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listeQrt.map(qrtRow =>
                                <TableRow key={qrtRow.qrtId}>
                                    <TableCell component="td" scope="row">
                                        <IconButton align="left">{qrtRow.qrtLibelle}</IconButton>
                                    </TableCell>
                                    <TableCell component="td" scope="row">
                                        <IconButton align="left">{qrtRow.qrtTirid.tirLibelle}</IconButton>
                                    </TableCell>
                                    <TableCell component="td" scope="row">
                                        <IconButton align="left" onClick={() => {
                                            deleteQrtbyId(qrtRow.qrtId);
                                        }}><Delete/></IconButton>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Paper>
            </SpinnerHexagone>
        )
}